<template>
	<div class="palette-container">
		<v-card
			outlined
			elevation="2"
			class="palette"
			v-for="palette in palettes"
			:key="palette.title"
			@click="chooseColorPalette(palette)"
		>
			<div>
				<h3>{{ palette.title }}</h3>
				<v-icon
					class="check-icon"
					small
					v-if="
						(getCurrentTemplate &&
							palette.title === getCurrentTemplate.title) ||
							(palette.title === 'Clásico' && getCurrentTemplate === null)
					"
				>
					zmdi-check
				</v-icon>
			</div>
			<div>
				<!-- <span>color principal</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['primary-color'] }"
				/>
			</div>
			<div>
				<!-- <span>color segundario</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['secondary-color'] }"
				/>
			</div>
			<div>
				<!-- <span>burbujas de chat</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['chat-bubble-color'] }"
				/>
			</div>
			<div>
				<!-- <span>botones principales</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['app-button'] }"
				/>
			</div>
			<div>
				<!-- <span>texto de botones</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['app-button-text'] }"
				/>
			</div>
			<div>
				<!-- <span>botones segundarios</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['secondary-app-button'] }"
				/>
			</div>
			<div>
				<!-- <span>fondo del chat</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['chat-bg'] }"
				/>
			</div>
			<div>
				<!-- <span>fondo de la pagina</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['main-bg'] }"
				/>
			</div>
			<div>
				<!-- <span>detalles del fondo</span> -->
				<span
					class="color-square"
					:style="{ backgroundColor: palette['main-bg-details'] }"
				/>
			</div>
		</v-card>
	</div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import api from "../../api/apibackend";
export default {
	data() {
		return {
			palettes: [
				{
					title: "Azul",
					"primary-color": "#22214A",
					"secondary-color": "#CADFEB",
					"chat-bubble-color": "#CADFEB",
					"app-button": "#22214A",
					"app-button-text": "#FFFFFF",
					"secondary-app-button": "#22214A",
					"chat-bg": "transparent",
					"main-bg": "#ffffff",
					"main-bg-details": "#ffffff",
				},
				{
					title: "Oscuro",
					"primary-color": "#FFFFFF",
					"secondary-color": "#000000",
					"chat-bubble-color": "#FFFFFF",
					"app-button": "#FCEA85",
					"app-button-text": "#000000",
					"secondary-app-button": "#FCEA85",
					"chat-bg": "transparent",
					"main-bg": "#000000",
					"main-bg-details": "#000000",
				},
				{
					title: "Claro",
					"primary-color": "#FBEB45",
					"secondary-color": "#22214A",
					"chat-bubble-color": "#FCEA85",
					"app-button": "#22214A",
					"app-button-text": "#fff",
					"secondary-app-button": "#22214A",
					"chat-bg": "transparent",
					"main-bg": "#FFFFFF",
					"main-bg-details": "#FFFFFF",
				},
				{
					title: "Clásico",
					"primary-color": "#ffec3d",
					"secondary-color": "#262261",
					"chat-bubble-color": "#ffec3d",
					"app-button": "#04c57a",
					"app-button-text": "#fff",
					"secondary-app-button": "#04c57a",
					"chat-bg": "transparent",
					"main-bg": "#262261",
					"main-bg-details": "#130153",
				},
			],
		};
	},
	methods: {
		...mapMutations(["setStyle"]),
		chooseColorPalette(palette) {
			let newPalette = {
				...this.getCurrentTemplate,
				title: palette.title,
				"primary-color": palette["primary-color"],
				"secondary-color": palette["secondary-color"],
				"chat-bubble-color": palette["chat-bubble-color"],
				"app-button": palette["app-button"],
				"app-button-text": palette["app-button-text"],
				"secondary-app-button": palette["secondary-app-button"],
				"chat-bg": palette["chat-bg"],
				"main-bg": palette["main-bg"],
				"main-bg-details": palette["main-bg-details"],
			};
			api
				.post("/store/templates/" + this.store.id, {
					template: [
						{
							...newPalette,
						},
					],
				})
				.then(() => {
					this.setStyle(newPalette);
				});
		},
	},
	computed: {
		...mapGetters(["getCurrentTemplate", "store"]),
	},
};
</script>
<style lang="scss">
.palette-container {
	width: 100%;
	padding: 10px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: space-around;
}
.palette {
	display: flex;
	flex-direction: column;
	min-width: 250px;
	width: 280px;
	margin: 10px 0;
	padding: 10px;
	cursor: pointer;
	div {
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		padding: 10px;
	}
	.color-square {
		width: 100%;
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
	}
}
</style>
